import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'

export const StarterPackItem = () => {
  const { classes } = useStyles()

  const kind = 1
  if (kind === 1) {
    return (
      <div className={classes.root}>
        <div className={classes.content} data-kind={kind}>
          <Icon view="gamedKey" style={{ width: '85%' }} />

          <span className={classes.itemValue}>x9</span>
        </div>

        <div className={classes.itemPriceContainer}>
          <span>Keys</span>
        </div>
      </div>
    )
  }
  if (kind === 2) {
    return (
      <div className={classes.root}>
        <div className={classes.content} data-kind={kind}>
          <img
            src="assets/lootBoxRelated/rewardsPreview/steamon!case/6.png"
            style={{ width: '85%', maxWidth: '91px' }}
          />
        </div>

        <div className={classes.itemPriceContainer}>
          <span>1 month</span>
        </div>
      </div>
    )
  }
}
